







import {Component} from "vue-property-decorator"
import Vue from "vue"
import JdiContent from "@/components/JdiContent.vue"

@Component({
    components: {JdiContent}
})
export default class Spacing extends Vue {
}
